import React from "react";
import { spring, interpolate, useCurrentFrame, useVideoConfig } from "remotion";

interface OutroProps {
  keywords: string[];
}

export const VelocityTechOutro: React.FC<OutroProps> = ({ keywords }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const entrance = spring({
    frame,
    fps,
    config: { stiffness: 100, damping: 12 },
  });

  const bgEntrance = interpolate(frame, [0, 15], [0, 1], {
    extrapolateRight: "clamp",
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        padding: "0 60px",
        gap: "60px",
        zIndex: 20,
      }}
    >
      <div
        style={{
          background: `rgba(0, 212, 255, ${0.05 * bgEntrance})`,
          border: `2px solid rgba(0, 212, 255, ${0.2 * bgEntrance})`,
          padding: "80px 40px",
          borderRadius: "12px",
          width: "100%",
          textAlign: "center",
          transform: `scale(${entrance})`,
          opacity: entrance,
          boxShadow: `0 0 40px rgba(0, 212, 255, ${0.1 * bgEntrance})`,
        }}
      >
        <h2
          style={{
            fontFamily: "'Outfit', sans-serif",
            fontSize: "48px",
            fontWeight: 800,
            color: "#ccff00",
            margin: "0 0 20px 0",
            textTransform: "uppercase",
            letterSpacing: "4px",
          }}
        >
          Stay Ahead
        </h2>
        <h3
          style={{
            fontFamily: "'Outfit', sans-serif",
            fontSize: "96px",
            fontWeight: 900,
            color: "white",
            margin: 0,
            lineHeight: 1,
            textTransform: "uppercase",
          }}
        >
          Subscribe
        </h3>
        <p
          style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: "24px",
            color: "#94a3b8",
            marginTop: "40px",
            fontWeight: 500,
          }}
        >
          Follow for more daily tech insights.
        </p>
      </div>

      <div
        style={{
          display: "flex",
          gap: "10px",
          opacity: entrance,
          transform: `translateY(${(1 - entrance) * 20}px)`,
        }}
      >
        {keywords.slice(0, 3).map((kw, i) => (
          <span
            key={i}
            style={{
              color: "#00d4ff",
              fontFamily: "'Inter', sans-serif",
              fontSize: "18px",
              fontWeight: 700,
              textTransform: "uppercase",
            }}
          >
            #{kw.replace(/\s+/g, "")}
          </span>
        ))}
      </div>
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
